export const materialStateEnum = {
    NEW: 0,
    PRESENT: 5,
    REMOVE: 10,
};
